var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{staticClass:"file-dialog--pdf",attrs:{"visible":_vm.visible,"title":"合同预览","width":"1000px","okButtonProps":{
    props: {loading: _vm.loading}
  }},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('div',{staticClass:"content__pdf"},[_c('iframe',{attrs:{"id":"PDF","src":_vm.filePath,"width":"100%","height":"800px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }